import { useRef } from "react";
import BurgerMenu from "../../../reusableUi/BurgerMenu";
import { Phone, ArrowLeft, Wrench, Clock, Shield, Star, Mail } from "lucide-react";
import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { Link, useNavigate } from "react-router-dom";
import ScrollableNavs from "../../../reusableUi/DropDownBar";

export default function LocationsHero() {
  
const TRUST_BADGES = [
  { icon: <Clock className="w-4 h-4" />, label: "24 / 7 Response" },
  { icon: <Shield className="w-4 h-4" />, label: "Licensed & Insured" },
  { icon: <Star className="w-4 h-4" />, label: "4.9★ Rated" },
];
  const navigate = useNavigate();
  const upSection = useRef(null);

  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <>
      <header className="max-w-[90%] mx-auto xl:max-w-6xl">

        {/* Mobile nav */}
        <nav className="md:hidden flex items-center justify-between py-5 mb-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <BurgerMenu />
        </nav>

        {/* Tablet nav */}
        <nav className="hidden max-lg:md:flex items-center justify-between py-5 mb-6">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-8">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="text-sm font-bold bg-blue-600 hover:bg-blue-700 transition-colors px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25">
                Contact Us
              </a>
            </li>
          </ul>
        </nav>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center justify-between py-6 mb-12">
          <Link to="/" className="flex items-center gap-3">
            <span className="w-9 h-9 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-2xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-10">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <a href="/services" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">View All Services</a>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="flex items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
                <Mail className="w-4 h-4" /> Contact
              </a>
            </li>
          </ul>
        </nav>

        <ScrollableNavs upSectionRef={upSection} />

        {/* Hero */}
        <div ref={upSection} className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8 items-center pb-18">

          {/* Copy */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                Serving All Chicago
              </div>
              <h1 className="font-black text-gray-900 text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Areas We <span className="text-blue-600">Serve</span>
              </h1>
              <p className="text-gray-500 text-lg leading-relaxed max-w-md">
                We provide fast, professional plumbing services throughout Chicago neighborhoods. Whether you're in a high-rise condo or a residential home, our team responds quickly and gets the job done right.
              </p>
            </div>
            <PrimaryButton />
          </div>

          {/* Map */}
          <div className="relative">
                         {/* Decorative offset frame */}
                         <div aria-hidden="true" className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10" />
            <iframe
              src="https://www.google.com/maps/d/embed?mid=1vq6TECACEAEVS6YDqMldpQJvW2Z9zBE&ehbc=2E312F&noprof=1"
              className="relative w-full h-96 rounded-2xl shadow-xl border-4 border-white"
              loading="lazy"
              title="Chicago Plumbing service area map"
            />
          </div>
        </div>
{/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-2.5 pt-0 pb-6">
              {TRUST_BADGES.map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-lg">
                  {icon}
                  {label}
                </div>
              ))}
            </div>
      </header>
    </>
  );
}